export const openInternalPopup = (url: string): void => {
  if (typeof screen === 'undefined') return;

  const width = 820;
  const height = 530;
  const left = (screen.width - width) / 2;
  const top = (screen.height - height) / 2;

  window.open(
    url,
    '',
    `width=${width}, height=${height}, left=${left}, top=${top}, resizable=1, scrollbars=1`
  );
};
